import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { NotFoundComponent } from './modules/not-found/not-found.component';

export const routes: Routes = [
    {
        path: '',
        title: 'Captire Portal',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadComponent: () => import('./modules/main-page/main-page.component').then(m => m.MainPageComponent)
            },
            {
                path: 'booking/:publicId',
                loadComponent: () => import('./modules/booking/booking.component').then(m => m.BookingComponent)
            },
            {
                path: 'tireshop-list',
                loadComponent: () => import('./modules/tireshop-list/tireshop-list.component').then(m => m.TireshopListComponent)
            },
            {
                path: "**",
                component: NotFoundComponent
            }
        ]

    },


];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
